<script>
  import AjaxEdit from '@triotech/vue-core/src/components/ajax/AjaxEdit';

  export default {
    extends: AjaxEdit,
    methods: {
      catchHandler(error) {
        const { data } = error.response;

        if (data.errors.children.qr_code.errors) {
          this.$notify({
            title: this.$t('flashes.qr.error'),
            text: this.$t('flashes.qr.invalid'),
            type: 'warning',
          });

          delete data.errors.children.qr_code.errors;
        }

        if (this._.some(data.errors.children, el => this._.has(el, 'errors'))) {
          this.parentCatchHandler(error);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/custom/AccessibilityAjaxEdit.vue